import { useEffect, useCallback } from "react";
import { Button } from "@/components/Buttons/index";
import { useMounted, useModal, useAuthUserQuery } from "@/hooks";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import styles from "@/styles/Modal.module.scss";

function ProfileSwitchModal() {
  const router = useRouter();
  const { hideModal } = useModal();
  const handleClick = useCallback(() => {
    hideModal();
    router.push(routes.profileSwitch(true));
  }, []);

  const handleBack = useCallback(() => router.back(), []);

  return (
    <div>
      <p className={styles.text}>
        この操作はオーナープロフィールで行ってください。
      </p>
      <div className={styles.buttons}>
        <Button large fillGray borderGray onClick={handleBack}>
          戻る
        </Button>
        <Button large fillColor fontFixed onClick={handleClick}>
          プロフィールを選択
        </Button>
      </div>
    </div>
  );
}

export function useRequireLogin(option = { ownerOnly: false }) {
  const router = useRouter();
  const mounted = useMounted();
  const { showModal } = useModal();
  const { data, loading } = useAuthUserQuery();

  useEffect(() => {
    if (mounted && !loading) {
      if (data?.user) {
        if (
          option.ownerOnly &&
          data?.user.currentProfile &&
          !data?.user?.currentProfile?.ownerProfile
        ) {
          showModal(<ProfileSwitchModal />, {
            style: "dialogue",
            closeButton: false,
            outerAreaClose: false,
          });
        }
      } else {
        router.push(routes.login);
      }
    }
  }, [mounted, loading, data?.user, option.ownerOnly]);
}
